/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Eyebrow_YouInputs */

const en_us2_profile_editors_eyebrow_you = /** @type {(inputs: Profile_Editors_Eyebrow_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};

const pt_br2_profile_editors_eyebrow_you = /** @type {(inputs: Profile_Editors_Eyebrow_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você`)
};

const es_419_profile_editors_eyebrow_you = /** @type {(inputs: Profile_Editors_Eyebrow_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú`)
};

const pt_pt2_profile_editors_eyebrow_you = /** @type {(inputs: Profile_Editors_Eyebrow_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu`)
};

const fr_fr2_profile_editors_eyebrow_you = /** @type {(inputs: Profile_Editors_Eyebrow_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toi`)
};

const de_de2_profile_editors_eyebrow_you = /** @type {(inputs: Profile_Editors_Eyebrow_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du`)
};

const it_it2_profile_editors_eyebrow_you = /** @type {(inputs: Profile_Editors_Eyebrow_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu`)
};

/**
* | output |
* | --- |
* | "You" |
*
* @param {Profile_Editors_Eyebrow_YouInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_eyebrow_you = /** @type {((inputs?: Profile_Editors_Eyebrow_YouInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Eyebrow_YouInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_eyebrow_you(inputs)
	if (locale === "es-419") return es_419_profile_editors_eyebrow_you(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_eyebrow_you(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_eyebrow_you(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_eyebrow_you(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_eyebrow_you(inputs)
	return en_us2_profile_editors_eyebrow_you(inputs)
});
export { profile_editors_eyebrow_you as "profile-editors.eyebrow_you" }